<template>
  <svg width="20"
       height="19"
       viewBox="0 0 20 19"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M9.99121 18.7422C14.9746 18.7422 19.0879 14.6289 19.0879 9.6543C19.0879 4.67969 14.9658 0.566406 9.98242 0.566406C5.00781 0.566406 0.90332 4.67969 0.90332 9.6543C0.90332 14.6289 5.0166 18.7422 9.99121 18.7422ZM9.99121 16.9316C5.95703 16.9316 2.73145 13.6885 2.73145 9.6543C2.73145 5.62012 5.95703 2.38574 9.98242 2.38574C14.0166 2.38574 17.2598 5.62012 17.2686 9.6543C17.2773 13.6885 14.0254 16.9316 9.99121 16.9316ZM5.56152 10.7617H9.98242C10.3867 10.7617 10.6943 10.4541 10.6943 10.0586V4.31055C10.6943 3.91504 10.3867 3.60742 9.98242 3.60742C9.5957 3.60742 9.28809 3.91504 9.28809 4.31055V9.35547H5.56152C5.16602 9.35547 4.8584 9.66309 4.8584 10.0586C4.8584 10.4541 5.16602 10.7617 5.56152 10.7617Z"
          :fill="color"/>
  </svg>

</template>

<script>
export default {
  name: 'ClockIcon',
  props: {
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 18
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }

}
</script>

<style>

</style>
